import React, { FC, useContext, useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { useStoreon } from 'storeon/react';
import cnBind from 'classnames/bind';
import dayjs from 'dayjs';
import classNames from 'classnames';
import {
  GxButton,
  GxCheckbox,
  GxForm,
  GxRadio,
} from '@garpix/garpix-web-components-react';

import PaymentMethod from '@/apps/Applications/components/PaymentMethod'
import InputForm from '@/components/InputForm'
import { api } from '@/api';
import { IOrder, IRetrieveOrder, IUserDepositList } from '@/types';
import { Events, State } from '@/interfaces';
import {
  DEPOSIT_PAYMENT_TITLE,
  NAME_STATUS,
  PAYMENT_TYPE,
  PAYMENT_TYPE_TITLE,
  TYPES_SCORE,
  TYPES_STATUS,
  validationSchemaPaymentCash,
} from '../../../../consts';
import InputNumbers from '../../../../../../components/InputNumbers';
import {
  counterPriceMultiOrders,
  createPayment,
  DEPOSITS_INFO,
} from '../../../../helpers';
import {
  ARR_TYPE,
  CHECK_TYPE,
  ORDERS,
  TITLE_DEPOSIT_NUll,
  TYPES_DEPOSITS,
} from '../../../../../../const';
import {
  NAME_TYPES_CERTIFICATE,
  TYPES_CERTIFICATE,
} from '../../../../../Certificates/const';
import { Context, TYPE_MODAL_ORDER } from '../../const';
import useModalFlag from '../../../../../../hooks/useModalFlag';
import ModalOrder from '../../index';
import { countPayment, countResurcePayment } from '../../helpers';
import { SIDEBAR_TYPES } from '../../../ModalPayCertificateOrDeposit/const';

import styles from './styles/index.module.scss';
import { IOrderWithFlags } from '../../interfaces';

interface IMultiPayOrder {
  onBack: () => void;
  data: IRetrieveOrder;
}

const MultiPayOrder: FC<IMultiPayOrder> = ({ onBack, data }) => {
  const cn = cnBind.bind(styles);

  const [{ info }, setOrderInfo] = useContext<any>(Context);

  const { id, pay_order, side } = info;
  const { certificate_rent_pay_count = 0 } = pay_order;
  const isRentResource = side === ORDERS.WAVE && certificate_rent_pay_count > 0;
  const resourceUnit = side === ORDERS.PIPE ? 'мин.' : (isRentResource ? 'аренд(ы)' : 'сет(ов)');


  const {
    typeOrder,
    depositListUser,
    certificatesUser,
    dispatch,
    ordersCheck,
  } = useStoreon<State, Events>(
    'typeOrder',
    'certificatesUser',
    'depositListUser',
    'ordersCheck'
  );


  const [activeItem, setActiveItem] = useState<PAYMENT_TYPE | null>(null);

  const priceInfo = counterPriceMultiOrders(pay_order);


  const [ordersList, setOrdersList] = useState<IOrderWithFlags[]>(
    pay_order.orders.map((item: IOrder) => {
      return {
        ...item,
        flag: true,
      };
    })
  );

  const orders = ordersList
    .filter((order) => order.flag)
    .map((item) => {
      return item.id;
    });

  const {
    flag: modalOrderOpen,
    setModalFlag: toggleFlagModalOrder,
  } = useModalFlag();

  const list = depositListUser[ARR_TYPE[data.side] as keyof IUserDepositList];

  const isNotMoneyDeposit = typeof list !== 'number'

  const depositList = DEPOSITS_INFO(depositListUser)
    .filter((el) =>
      data.side === ORDERS.PIPE
        ? el.id === TYPES_DEPOSITS.PIPE
        : el.id === TYPES_DEPOSITS.WAVE
    )

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema: validationSchemaPaymentCash,
    initialValues: {
      amount: priceInfo.price,
      deposit_type: TYPES_DEPOSITS.MONEY,
      certificate_id: undefined,
      deposit_id: undefined,
      comment: '',
      isAll: true,
    },
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (values) => {
      try {
        if(activeItem == null){
          return
        }
        const depositType = values.deposit_type === TYPES_DEPOSITS.MONEY ? PAYMENT_TYPE.FROM_DEPOSIT_RUBLES : PAYMENT_TYPE.FROM_DEPOSIT_MINUTES
        if (ordersList.length !== orders.length) {
          ordersList
            .filter((order: Record<string, any>) => order.flag)
            .forEach((item: Record<string, any>) => {
              createPayment(
                {
                  data: {
                    amount:
                      activeItem === PAYMENT_TYPE.CERTIFICATE ||
                        Number(values.deposit_type) === TYPES_DEPOSITS.PIPE ||
                        Number(values.deposit_type) === TYPES_DEPOSITS.WAVE
                        ? item.side === ORDERS.PIPE
                          ? item.tariff_rate.minutes
                          : item.tariff_rate.count_people
                        : Number(item.price),
                    order_id: item.id,
                    comment: values.comment,
                    deposit_id: activeItem === PAYMENT_TYPE.DEPOSITS ? values.deposit_id : undefined,
                    certificate_id:
                      activeItem === PAYMENT_TYPE.CERTIFICATE
                        ? values.certificate_id
                        : undefined,
                    payment_method:
                      activeItem === PAYMENT_TYPE.DEPOSITS
                        ? depositType
                        : activeItem,
                    is_mass_booking: false,
                  },
                  name: PAYMENT_TYPE_TITLE[activeItem !== PAYMENT_TYPE.DEPOSITS ? activeItem : PAYMENT_TYPE.FROM_DEPOSIT_MINUTES].title,
                typePayment: `Счет №${data.pay_order.id}. Заявка №${item.id}`
              }
              ).then(() => {
                updateOrder();
              });
            });
        } else {
          createPayment(
            {
              data: {
                amount: values.deposit_type === TYPES_DEPOSITS.MONEY ? String(values.amount) : '0',
                order_id: id,
                comment: values.comment,
                deposit_id: activeItem === PAYMENT_TYPE.DEPOSITS ? values.deposit_id : undefined,
                certificate_id:
                  activeItem === PAYMENT_TYPE.CERTIFICATE
                    ? values.certificate_id
                    : undefined,
                payment_method:
                  activeItem === PAYMENT_TYPE.DEPOSITS
                    ? depositType
                    : activeItem,
                is_mass_booking: true,
              },
              name: PAYMENT_TYPE_TITLE[activeItem !== PAYMENT_TYPE.DEPOSITS ? activeItem : PAYMENT_TYPE.FROM_DEPOSIT_MINUTES].title,
              typePayment: `Счет №${data.pay_order.id}`
            }
          ).then(() => {
            updateOrder();
          });
        }
        dispatch('orders/get');
      } catch (e) {
        console.log(e);
      }
    },
  });

  const { base_price } = countPayment(
    ordersList,
    activeItem,
    formik
  );

  const type_flag =
    activeItem === PAYMENT_TYPE.CERTIFICATE ||
    formik.values.deposit_type !== TYPES_DEPOSITS.MONEY;

  const [orderModalInfo, setOrderModalInfo] = useState<Record<
    string,
    any
  > | null>({});


  const changeOrderFlag = (id: number) => {
    const newOrder = ordersList.map((item) => {
      if (id === item.id) {
        return {
          ...item,
          flag: !item.flag,
        };
      }
      return item;
    });
    setOrdersList(newOrder);
  };

  const updateOrder = async () => {
    const response = await api.order.getOrder(id);
    setOrderInfo({
      visibleItem: TYPE_MODAL_ORDER.DEFAULT,
      info: response,
    });
  };

  const getFlag = (item: Record<string, any>, flag: boolean) => {
    return ordersCheck.findIndex((el) => el === item.id) !== -1 ? flag : false
  }

  const changeAllItem = (flag: boolean) => {
    try {
      formik.setFieldValue('isAll', flag);

      const orders = pay_order.orders.map((item: Record<string, any>) => {
        const currentFlag = !type_flag ? flag : getFlag(item, flag)
        return {
          ...item,
          flag: currentFlag
        };
      })

      setOrdersList(orders);
    } catch (e) {
      console.log(e);
    }
  };

  const getOrders = (type: CHECK_TYPE, id: any) => {
    changeAllItem(false);

    dispatch('ordersCheck', {
      type,
      data: {
        id,
        orders: pay_order.orders.map((item: Record<string, any>) => item.id)
      },
    });
  };


  const handleClickModal = (
    date: string | null,
    order: Record<string, any> | null
  ) => {

    setOrderModalInfo({ date, order });
    toggleFlagModalOrder();
  };

  const depsFiltered = isNotMoneyDeposit ? list.filter((item) =>
    item.expiry_at === null
      ? true
      : dayjs(item.expiry_at).isSameOrAfter(dayjs())
  ) : [];


  const getDepositListUser = (item: any) =>{
    dispatch('depositListUser/get', {
      user_id: data.customer.id,
      is_has_resource: true,
      side: data.side,
      user_type: `0,${item.id}`,
      order: ordersList?.map((el) => el.id)?.join(),
    });
  }

  const typeConditionsSide = {
    [SIDEBAR_TYPES.PIPE]: data.customer.tube_user_type,
    [SIDEBAR_TYPES.WAVE]: data.customer.wave_user_type,
  } as const

  useEffect(() => {
    if (data) {
      api.user.getUserTypes().then(({ results }) => {
        // по условию по дефолту будет всегда сравниваться с data.customer.tube_user_type, что соответсвует условиям которые здесь были до рефактора
        const condition =
          data.user_type_slug !== ''
            ? data.user_type_slug
            : typeConditionsSide?.[data.side as keyof typeof typeConditionsSide] ||
              typeConditionsSide[SIDEBAR_TYPES.PIPE as keyof typeof typeConditionsSide]
        results.filter((item) => {
          if (item.slug === condition) {
            getDepositListUser(item)
          }
          return false;
        });
      });

      dispatch('certificatesUser/get', {
        customer_id: data.customer.id,
        status: 3,
        side: data.side,
      });
    }
    return () => {
      dispatch('ordersCheck/save', []);
    };
  }, [data]);

  useEffect(() => {
    changeAllItem(false);
    if (activeItem === PAYMENT_TYPE.DEPOSITS) {
      formik.setFieldValue('deposit_type', TYPES_DEPOSITS.MONEY);
    }
  }, [activeItem]);

  useEffect(() => {
    if (
      formik.values.deposit_type !== TYPES_DEPOSITS.MONEY &&
      depsFiltered.length > 0
    ) {
      formik.setFieldValue('deposit_id', depsFiltered[0].id);
      getOrders(CHECK_TYPE.DEPOSIT, depsFiltered[0].id);
    }
  }, [formik.values.deposit_type]);

  useEffect(() => {
    if (ordersCheck.length > 0) {
      setOrdersList(
        pay_order.orders.map((item: Record<string, any>) => {
          return {
            ...item,
            flag: ordersCheck.findIndex((el) => el === item.id) !== -1,
          };
        })
      );
    }
  }, [ordersCheck]);

  useEffect(() => {
    if (activeItem !== PAYMENT_TYPE.CERTIFICATE && formik.values.certificate_id ){
      formik.setFieldValue('certificate_id', undefined)
    }

    setOrdersList(
      pay_order.orders.map((item: Record<string, any>) => {
        return {
          ...item,
          flag: false,
        };
      })
    );
    dispatch('ordersCheck/save', []);
  }, [activeItem]);

  useEffect(() => {
    if (activeItem !== null) {
      const { amount } = countResurcePayment(activeItem, ordersList, formik);
      formik.setFieldValue('amount', amount);
    }
  }, [activeItem, ordersList, formik.values]);

  useEffect(() => {
    const count = ordersList
      .filter((order) => order.flag)
      .reduce((previousValue: number) => {
        return previousValue + 1;
      }, 0);

    formik.setFieldValue(
      'isAll',
      count > 0 && count ===
        (!type_flag
          ? ordersList.length
          : ordersList.filter(
              (item) =>
                ordersCheck.findIndex((el) => el === item.id) !== -1
            ).length)
    );
  }, [ordersList]);

  const getValueDepositField = (item: any) => {
    if (formik.values.deposit_type === TYPES_DEPOSITS.WAVE) {
      if (item.rent_pay_count) {
        return `${item.rent_pay_count} аренд(ы)`;
      }
      return `${item.sets} сет.`;
    }
    return `${item.minutes || 0} мин.`;
  };

  const certificateClass = (item: IOrderWithFlags): string => {
    const isCertificateInterval = ordersCheck.findIndex((el) => el === item.id) !== -1 && type_flag

    if (isSetCertificate && !isCertificateInterval) return styles.danger

    if (isCertificateInterval) return styles.disable

    return ''
  }

  const isSetCertificate = activeItem === PAYMENT_TYPE.CERTIFICATE && formik.values.certificate_id
  const getCertificateWaveResource = (item: any): string | number => {
    const isRent = item.side === ORDERS.WAVE && item.remaining_rent_pays > 0;

    if (isRent) {
      return `${item.remaining_rent_pays} аренд(ы)`;
    }

    if (item.side === ORDERS.WAVE || (item.side !== ORDERS.PIPE && item.side !== ORDERS.WAVE)) {
      return `${item.remaining_sets_wave} сет(ов)`;
    }

    return 0;
  };

  return (
    <>
      <GxForm onGx-submit={formik.submitForm}>
        {pay_order.status !== TYPES_SCORE.PAY_SUCCESS && (
          <>
            <div className={styles['subheader']}>
              <span className={styles['subheader--subtitle']}>
                Способ оплаты:
              </span>
            </div>
            <PaymentMethod setActiveItem={setActiveItem} activeItem={activeItem}/>

            <div className={styles['wrap-group']}>
              <div className={styles['group']}>
                <InputNumbers
                  label='Сумма оплаты:'
                  name='amount'
                  value={formik.values.amount}
                  handleInput={(e: Record<string, any>) => {
                    formik.setFieldValue('amount', e.target.value);
                  }}
                  disabled
                  className={cn({
                    'group--input': true,
                    'group--input--error': formik.errors.amount,
                  })}
                  type='number'
                />
                {activeItem === PAYMENT_TYPE.CERTIFICATE ||
                (activeItem === PAYMENT_TYPE.DEPOSITS &&
                  formik.values.deposit_type !== TYPES_DEPOSITS.MONEY) ? (
                  <span> {resourceUnit}</span>
                ) : (
                  <span className={styles['symbol--price']} />
                )}

                <p className={styles['group--error']}>{formik.errors.amount}</p>
              </div>
              <div className={styles['group']}>
                <InputForm
                  formik={formik}
                  label='Примечание:'
                  name='comment'
                  className={cn(styles['group--input'])}
                />
              </div>
            </div>
          </>
        )}
        {activeItem === PAYMENT_TYPE.DEPOSITS && (
          <div className={styles['deposit-pay']}>
            <div className={styles['certificate']}>
              <div className={styles['subheader']}>
                <span className={styles['subheader--subtitle']}>
                  Выбор депозита
                </span>
              </div>
              <div className={cn(styles['table'], styles['table--deposit'])}>
                <table
                  style={{
                    display: 'table',
                    maxWidth: '100%',
                  }}
                >
                  <thead>
                    <tr>
                      <th>Название</th>
                      <th>Сумма</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <GxRadio
                          onGx-change={() =>
                            formik.setFieldValue(
                              'deposit_type',
                              TYPES_DEPOSITS.MONEY
                            )
                          }
                          name='typeCertificate'
                          checked={
                            formik.values.deposit_type === TYPES_DEPOSITS.MONEY
                          }
                        >
                          {DEPOSIT_PAYMENT_TITLE.MONEY}
                        </GxRadio>
                      </td>
                      <td>
                        {Number(data.customer.deposit_money).toLocaleString()}{' '}
                        &#8381;
                      </td>
                    </tr>
                    {depositList.map((item) => (
                        <tr key={item.id}>
                          <td>
                            <GxRadio
                              onGx-change={() =>
                                formik.setFieldValue('deposit_type', item.id)
                              }
                              name='typeCertificate'
                              checked={formik.values.deposit_type === item.id}
                            >
                              {item.title}
                            </GxRadio>
                          </td>
                          <td>{item.count_price}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
              <div className={cn(styles['table'], styles['table--deposit'])}>
                {formik.values.deposit_type !== TYPES_DEPOSITS.MONEY && (
                  <>
                    {isNotMoneyDeposit && list.filter((item: Record<string, any>) =>
                      item.expiry_at === null
                        ? true
                        : dayjs(item.expiry_at).isSameOrAfter(dayjs())
                    ).length === 0 ? (
                      <div className={styles['info']}>
                        {TITLE_DEPOSIT_NUll[formik.values.deposit_type]}
                        депозиты отсутствуют...
                      </div>
                    ) : (
                      <>
                        <table>
                          <thead>
                            <tr>
                              <th>Название</th>
                              <th>Действителен до</th>
                              <th>Ресурс</th>
                            </tr>
                          </thead>
                          <tbody>
                            {isNotMoneyDeposit && list
                              .filter((item) =>
                                item.expiry_at === null
                                  ? true
                                  : dayjs(item.expiry_at).isSameOrAfter(dayjs())
                              )
                              .map((item) => (
                                <tr key={item.id} className={classNames({[styles['table--not-in-interval']]: item.is_in_interval === false})}>
                                  <td>
                                    <GxRadio
                                      name='deposit'
                                      onClick={() => {
                                        formik.setFieldValue(
                                          'deposit_id',
                                          item.id
                                        );
                                        formik.setFieldValue(
                                          'certificate_id',
                                          null
                                        );
                                        getOrders(CHECK_TYPE.DEPOSIT, item.id);
                                      }}
                                      checked={
                                        formik.values.deposit_id === item.id
                                      }
                                    >
                                      {item.title}
                                    </GxRadio>
                                  </td>
                                  <td>
                                    {!item.expiry_at
                                      ? '-'
                                      : dayjs(item.expiry_at).format(
                                          'YYYY.MM.DD'
                                        )}
                                  </td>
                                  <td>{getValueDepositField(item)}</td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        )}
        {activeItem === PAYMENT_TYPE.CERTIFICATE && (
          <div className={styles['certificate']}>
            <div className={styles['subheader']}>
              <span className={styles['subheader--subtitle']}>
                Выбор сертификата
              </span>
            </div>
            <div className={cn(styles['table'], styles['table--certificate'])}>
              <table>
                <thead>
                  <tr>
                    <th>Номер-серия</th>
                    <th>Действителен до</th>
                    <th>Цена</th>
                    <th>Труба, мин.</th>
                    <th>Волна, ар./сеты.</th>
                    <th>Статус</th>
                  </tr>
                </thead>
                <tbody>
                  {certificatesUser.results
                    .filter(
                      (el) =>
                        el.side === 0 || el.side === typeOrder
                    )
                    .map((item) => (
                      <tr key={item.id}
                        className={
                          item.is_in_interval ? '' : styles['table--certificate--danger']
                        }
                      >
                        <td>
                          <GxRadio
                            onClick={() => {
                              getOrders(CHECK_TYPE.CERTIFICATE, item.id);
                              formik.setFieldValue('certificate_id', item.id);
                              formik.setFieldValue('deposit_id', null);
                            }}
                            name='typeCertificate'
                            checked={formik.values.certificate_id === item.id}
                          >
                          {item.number_series}
                          </GxRadio>
                        </td>
                        <td>
                          {item.date_validity
                            ? dayjs(item.date_validity).format('YYYY.MM.DD')
                            : '-'}
                        </td>
                        <td>{Number(item.price_paid).toLocaleString()}</td>
                        <td>{item.remaining_minutes_fly}</td>
                        <td>{getCertificateWaveResource(item)}</td>
                        <td>
                          <span
                            className={cn(
                              styles['table--status-cert'],
                              styles[
                                `table--status-cert_${
                                  NAME_TYPES_CERTIFICATE[
                                    TYPES_CERTIFICATE[item.status]
                                  ].class
                                }`
                              ]
                            )}
                          >
                            {
                              NAME_TYPES_CERTIFICATE[
                                TYPES_CERTIFICATE[item.status]
                              ].title
                            }
                          </span>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
        <div className={styles['subheader']}>
          <span className={styles['subheader--subtitle']}>Заявки</span>
        </div>
        {pay_order.status !== TYPES_SCORE.PAY_SUCCESS && (
          <div className={styles['footer--left-block']}>
            <GxCheckbox
              className={styles['footer--pay']}
              name='isAll'
              checked={formik.values.isAll}
              onGx-change={(e: Record<string, any>) =>{
                  changeAllItem(e.target.checked)
                }
              }
            >
              Все заявки
            </GxCheckbox>
          </div>
        )}
        <div className={cn(styles['table'], styles['table--orders'])}>
          <table className={styles['orders']}>
            <thead>
              <tr>
                <th>№ Заявки</th>
                <th>Тариф</th>
                <th>Дата</th>
                <th>Время</th>
                <th>Цена</th>
                <th>Оплачено</th>
                <th>Статус</th>
              </tr>
            </thead>
            <tbody>
              {ordersList.map((item) => (
                <tr
                  key={item.id}
                  className={certificateClass(item)}
                >
                  <td className={styles['title']}>
                    {pay_order.status !== TYPES_SCORE.PAY_SUCCESS && (
                      <GxCheckbox
                        name='checkbox'
                        checked={item.flag}
                        onGx-change={() => changeOrderFlag(item.id)}
                      />
                    )}
                    <p onClick={() => handleClickModal(item.start_at, item)}>
                      № {item.number}
                    </p>
                  </td>
                  <td>{item.tariff?.title}</td>
                  <td>{dayjs(item.start_at).format('DD.MM.YYYY')}</td>
                  <td>{dayjs(item.start_at).format('HH:mm')}</td>
                  <td className={styles['table--item']}>
                    {Number(item.price)} &#8381; /{' '}
                    {item.side === ORDERS.PIPE
                      ? `${item.tariff_rate?.minutes} мин.`
                      : `${item.tariff_rate?.count_people} сет(ов)`}
                  </td>
                  <td className={styles['table--item']}>
                    {Number(item.price_paid)} &#8381;{' '}
                    {item.certificate_name
                      ? `/ ${
                          item.side === ORDERS.PIPE
                            ? item.certificate_mins_paid
                            : item.certificate_sets_paid
                        } ${item.side === ORDERS.PIPE ? 'мин.' : 'сет(ов)'}`
                      : item.deposit_name
                      ? `/ ${
                          item.side === ORDERS.PIPE
                            ? item.deposit_mins_paid
                            : item.deposit_sets_paid
                        } ${item.side === ORDERS.PIPE ? 'мин.' : 'сет(ов)'}`
                      : ''}
                  </td>
                  <td>
                    <span
                      className={cn(
                        styles['table--item__status'],
                        styles[
                          `table--item__status--${
                            NAME_STATUS[TYPES_STATUS[item.status]].class
                          }`
                        ]
                      )}
                    >
                      {NAME_STATUS[TYPES_STATUS[item.status]].title}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className={styles['footer']}>
          <div className={styles['footer--left-block']}>
            <div className={styles['pay-info']}>
              <div className={styles['pay-info__item']}>
                <p className={styles['pay-info__item_label']}>Сумма заказа:</p>
                <p className={styles['pay-info__item']}>
                  <span className={styles['pay-info__item']}>
                    {String(base_price).toLocaleString()}
                  </span>
                  {activeItem === PAYMENT_TYPE.CERTIFICATE ||
                  (activeItem === PAYMENT_TYPE.DEPOSITS &&
                    formik.values.deposit_type !== TYPES_DEPOSITS.MONEY) ? (
                    <span style={{ marginLeft: 5 }}>
                      {' '}
                      {resourceUnit}
                    </span>
                  ) : (
                    <span style={{ marginLeft: 5 }}> ₽</span>
                  )}
                </p>
              </div>
              <div
                className={cn(
                  styles['pay-info__item'],
                  styles['pay-info__item_paid']
                )}
              >
                <p className={styles['pay-info__item_label']}>Оплачено:</p>
                <p className={styles['pay-info__item']}>
                  {String(priceInfo.price_paid_money).toLocaleString()} ₽
                  <span className={styles['pay-info__item_price']} />
                  {priceInfo.price_paid_resource !== 0 &&
                    `/ ${priceInfo.price_paid_resource} ${
                      typeOrder === ORDERS.PIPE ? 'мин.' : 'сет(ов)'
                    }`}
                </p>
              </div>
              <div className={cn(styles['pay-info__item_container'])}>
                <div
                  className={cn(
                    styles['pay-info__item'],
                    styles['pay-info__item_total']
                  )}
                >
                  <p className={styles['pay-info__item_label']}>
                    К оплате (руб):
                  </p>
                  <p className={styles['pay-info__item_total']}>
                    <span className={styles['pay-info__item']}>
                      {String(formik.values.amount).toLocaleString()}
                    </span>
                    {activeItem === PAYMENT_TYPE.CERTIFICATE ||
                    (activeItem === PAYMENT_TYPE.DEPOSITS &&
                      formik.values.deposit_type !== TYPES_DEPOSITS.MONEY) ? (
                      <span style={{ marginLeft: 5 }}>
                        {' '}
                        {resourceUnit}
                      </span>
                    ) : (
                      <span style={{ marginLeft: 5 }}> ₽</span>
                    )}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className={styles['footer--right-block']}>
            <GxButton className={styles['btn--gray']} onClick={onBack}>
              Отмена
            </GxButton>
            <GxButton
              className={styles['btn--default']}
              type='submit'
              disabled={
                priceInfo.total_money === 0 ||
                Number(formik.values.amount) === 0||
                activeItem === null
              }
            >
              Оплатить
            </GxButton>
          </div>
        </div>
      </GxForm>
      {modalOrderOpen && (
        <ModalOrder
          data={orderModalInfo?.order}
          date={orderModalInfo?.date}
          flag={modalOrderOpen}
          closeModal={toggleFlagModalOrder}
        />
      )}
    </>
  );
};

export default MultiPayOrder;
